import mergeMemberRecords from '@/lib/settings/members/mergeMemberRecords.js';

const buildVisibleMembersPayload = ({ serverPayload = [], pendingMutations = [] } = {}) => {
  const optimisticMembers = (Array.isArray(pendingMutations) ? pendingMutations : [])
    .map((mutation) => {
      return mutation?.member && typeof mutation.member === 'object' ? mutation.member : null;
    })
    .filter(Boolean);

  return mergeMemberRecords({
    currentMembers: serverPayload,
    nextMembers: optimisticMembers
  });
};

export default buildVisibleMembersPayload;
